export class LocalData {
    version = 0;

    private static clearCookies = (document: any, window: any, location: any): any => {
      const cookies = document.cookie.split("; ");
      for (let c = 0; c < cookies.length; c++) {
        const d = window.location.hostname.split(".");
        while (d.length > 0) {
          const cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
          const p = location.pathname.split('/');
          document.cookie = cookieBase + '/';
          while (p.length > 0) {
            document.cookie = cookieBase + p.join('/');
            p.pop();
          }
          d.shift();
        }
      }
    }

    private static clearCache = (window: any): any => window.location.reload(true);
    
    private static clearSession = (window: any): any => window.sessionStorage.clear();
    
    private static clearLocalStorage = (window: any): any => window.localStorage.clear();

    static clearData = (document: any, window: any, location: any): any => {
      this.clearCookies(document, window, location)
      this.clearCache(window)
      this.clearSession(window)
      this.clearLocalStorage(window)
    }
}
